import React from 'react';
import {
  getFilter,
  getLabel,
  getSort,
  userName,
} from '../Common/DataTable/tableHelpers';
import { capitalize } from '../../helpers/sharedFunction';

const createTableColumns = (
  acquisitionOrders,
  monetizationOrders,
  users,
  t,
) => [
  {
    title: 'Acquisition Order',
    name: 'acquisitionOrderId',
    formatterComponent: ({ value }) => getLabel(value, acquisitionOrders),
    sorting: (a, b) =>
      getSort(getLabel(a, acquisitionOrders), getLabel(b, acquisitionOrders)),
    filter: (value, filter) =>
      getFilter(getLabel(value, acquisitionOrders), filter.value),
  },
  {
    title: 'Closure',
    width: 160,
    name: 'closure',
    formatterComponent: ({ row }) =>
      row.revenue > 0 && row.status === 'closed' ? (
        <span className="badge badge-success font-size-12">
          {t('Positive Closure')}
        </span>
      ) : (
        <span className="badge badge-danger font-size-12">
          {t('Negative Closure')}
        </span>
      ),
    filter: (value, filter, row) =>
      getFilter(
        `${
          row.revenue > 0 && row.status === 'closed' ? 'positive' : 'negative'
        } closure`,
        filter.value,
      ),
    sorting: 'disabled',
  },
  {
    title: 'Closure At',
    name: 'createdAt',
    width: 250,
    formatterComponent: ({ value }) => t('date_fromNow', { date: value }),
    filter: (value, filter) =>
      getFilter(t('date_fromNow', { date: value }), filter.value),
  },
  {
    title: 'Monetization Order',
    name: 'monetizationOrderId',
    formatterComponent: ({ value }) => getLabel(value, monetizationOrders),
    sorting: (a, b) =>
      getSort(getLabel(a, monetizationOrders), getLabel(b, monetizationOrders)),
    filter: (value, filter) =>
      getFilter(getLabel(value, monetizationOrders), filter.value),
  },
  {
    title: 'Outcome',
    name: 'outcome',
    formatterComponent: ({ row }) =>
      row.positiveOutcome || row.negativeOutcome
        ? t(capitalize(row.positiveOutcome || row.negativeOutcome))
        : '',
    filter: (value, filter, row) =>
      getFilter(
        row.positiveOutcome || row.negativeOutcome
          ? t(capitalize(row.positiveOutcome || row.negativeOutcome))
          : '',
        filter.value,
      ),
    sorting: 'disabled',
  },
  {
    title: 'Operator',
    name: 'userId',
    width: 150,
    formatterComponent: ({ value }) => userName(value, users),
    sorting: (a, b) => getSort(userName(a, users), userName(b, users)),
    filter: (value, filter) => getFilter(userName(value, users), filter.value),
  },
];

export default createTableColumns;
